import { inject, Injectable, Type } from '@angular/core';
import { MDDialogService } from '@melodic-ui/components';
import { IntegrationDialogComponent } from './integration-dialog.component';

@Injectable({
	providedIn: 'root'
})
export class IntegrationDialogService {
	private _dialogService = inject(MDDialogService);

	/**
	 * Entity type mapping from string names to numeric values
	 */
	private getEntityTypeNumber(entityTypeName: string): number {
		const entityTypes: { [key: string]: number } = {
			User: 1,
			Enrollment: 2,
			Lesson: 3,
			Payment: 4,
			Institution: 5
		};

		return entityTypes[entityTypeName] || 2; // Default to Enrollment
	}

	/**
	 * Opens the integration dialog for a specific entity
	 * @param entityGuid The GUID of the entity to view integrations for
	 * @param options Additional options for the dialog
	 */
	openIntegrationDialog(
		entityGuid: string,
		options: {
			entityType?: string;
			readonly?: boolean;
		} = {}
	) {
		return this._dialogService.open(IntegrationDialogComponent as Type<any>, {
			entityGuid,
			entityType: this.getEntityTypeNumber(options.entityType || 'Enrollment'),
			readonly: options.readonly || false
		});
	}
}
